import React from 'react'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'
import { RichText } from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import { Logo } from '@/components/brand/Logo'
import { backgroundClasses, isDarkBackground, type Background } from '@/fields/background'
import { cn } from '@/utilities/cn'

/** Цветная плашка во всю ширину с крупным текстом и кнопками. */
export const CallToActionBlock: React.FC<
  CTABlockProps & {
    id?: string | number
    className?: string
  }
> = ({ links, richText, background }) => {
  const bg = (background as Background) ?? 'punch'
  const light = isDarkBackground(bg)

  return (
    <section className={cn('relative overflow-hidden py-20 md:py-28', backgroundClasses[bg])}>
      <Logo
        variant="sun"
        title=""
        aria-hidden
        className={cn('pointer-events-none absolute -left-24 -bottom-32 h-80 w-auto md:h-[28rem]', light ? 'text-white/10' : 'text-ink/10')}
      />
      <div className="container relative flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div
          className={cn(
            'max-w-3xl [&_h2]:font-display [&_h2]:text-[clamp(2rem,5vw,4rem)] [&_h2]:leading-[1] [&_h2]:mb-4 [&_h3]:font-display [&_h3]:text-2xl [&_p]:text-lg [&_p]:md:text-xl',
            light ? '[&_p]:text-white/85' : '[&_p]:text-ink/80',
          )}
        >
          {richText && <RichText className="mb-0" data={richText} enableGutter={false} enableProse={false} />}
        </div>
        {(links || []).length > 0 && (
          <div className="flex flex-wrap gap-3 md:flex-col md:items-end">
            {(links || []).map(({ link }, i) => (
              <CMSLink key={i} size="lg" {...link} />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
